import { render, staticRenderFns } from "./Stances.vue?vue&type=template&id=4a836e50&"
import script from "./Stances.vue?vue&type=script&lang=js&"
export * from "./Stances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports